import React from 'react'

import { useDevice } from 'src/hooks/useDevice'
import { useSession } from 'src/hooks/useSession'
import { BreakpointSizes } from 'src/types/device'

import HeaderWithSlots, { HeaderWithSlotsProps } from 'client/components/HeaderWithSlots'

import HeaderLogo from '../HeaderLogo'
import { RightSideWrapper, UserActions } from './styles'
import LoginButton from 'src/comps/LoginButton'
import { CountrySelector } from '../CountrySelector'
import { Button } from '@s4l/ds'
import { IconArrowLeft } from '@s4l/icons/IconArrowLeft'
import { useRouter } from 'next/router'

type IMinimalHeaderProps = Partial<HeaderWithSlotsProps> & {
  pageId: string
}

function MinimalHeader(props: IMinimalHeaderProps) {
  const { center, bottom, fixed, pageId } = props

  const { currentUserHasPrimeSubscription } = useSession()
  const { activeBreakpoint } = useDevice()
  const router = useRouter()

  const showLogo = () => {
    if (activeBreakpoint < BreakpointSizes.M) {
      return (
        <Button
          variant="icon-rounded"
          size="small"
          leadingIcon={<IconArrowLeft />}
          onClick={router.back}
        />
      )
    }
    return <HeaderLogo pageId={pageId} isPrime={currentUserHasPrimeSubscription} />
  }

  return (
    <HeaderWithSlots
      left={showLogo()}
      center={center}
      right={
        <RightSideWrapper isSearch>
          <UserActions>
            {activeBreakpoint >= BreakpointSizes.M && <CountrySelector />}
            <LoginButton />
          </UserActions>
        </RightSideWrapper>
      }
      bottom={bottom}
      fixed={fixed}
    />
  )
}

export default MinimalHeader
